import { createModule } from '../../actions/utils';
import { SERVICE_ENDPOINT } from '../../apis/constants';

const GetQualityChecksWorkflows = createModule(
  { base: 'GET_QUALITY_CHECKS_WORKFLOWS', apiDetails: SERVICE_ENDPOINT.WORKFLOWS },
);

const UpdateQualityChecksStatus = createModule({
  base: 'UPDATE_QUALITY_CHECKS_STATUS',
  apiDetails: { url: `${SERVICE_ENDPOINT.QUALITY_CHECKS.url}/status`, method: 'put' },
  enableNotification: true,
  customNotificationSuccessMessage: 'Quality checks status updated successfully',
});

const UpdateQualityChecksWorkflowStep = createModule({
  base: 'UPDATE_QUALITY_CHECKS_WORKFLOW_STEP',
  apiDetails: { url: `${SERVICE_ENDPOINT.QUALITY_CHECKS.url}/workflow`, method: 'post' },
});

export { GetQualityChecksWorkflows, UpdateQualityChecksStatus, UpdateQualityChecksWorkflowStep };
